/**
 * Created by sswaminathan on 5/30/22
 * File: SDWANButtonRenderer
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { Body, Button } from '@panwds/react-ui'
/**
 *   TODO: Brief what is this component/class do
 */
import { DATA_TEST_CLAIM_LICENSE } from '../constants/TestingDataIds'
import { ACTIVATE_SDWAN } from '../../../tenancy/constants/LabelConstants'

const SDWANButtonRenderer = (props) => {

  const { action, row, title, handleSubmit, rest, claimsModal } = props

  return (<div className='tw-flex-col tw-flex tw-mt-6'>
    <div className="tw-mx-4 tw-pl-6">
      <Button appearance="primary" disabled={row.original.block_claim} size="md"
        data-testid={DATA_TEST_CLAIM_LICENSE}
        onClick={() => claimsModal.openModal({ title: title, row, handleSubmit: handleSubmit, ...rest })}>
        {action}
      </Button>
    </div>
    <div className="claim-box tw-mt-3 tw-text-center tw-pt-2">
      <Body size='sm' addClassName='tw-text-gray-600'>{ACTIVATE_SDWAN}</Body>
      <div className="claim-arrow claim-arrow-top"/>
    </div>
  </div>)
}

SDWANButtonRenderer.propTypes = {}
export default SDWANButtonRenderer
